import { LinkInfo } from "../models/shared/LinkInfo";
import { isNullOrWhiteSpace } from "../shared/string";

export const isValidLink = (link?: LinkInfo): link is LinkInfo => {
    if (!link) {
        return false;
    }

    if (link.isExternalLink) {
        return !isNullOrWhiteSpace(link.url);
    }
    else {
        return !!link.reference
            || !!link.fileReference
            || !!link.imageReference;
    }
};

export const formatPhoneNumberLink = (phoneNumber: string | null | undefined) => {
    if (!phoneNumber?.length) {
        return undefined;
    }

    const formattedPhoneNumber = phoneNumber
        .replace(/\s/, "")
        .replace(/\//, "-");

    return `tel:${formattedPhoneNumber}`;
};
